import React, { useState, useEffect } from "react";
import RegistrationForm from "./RegistrationForm.js";
import { useLoading } from "../../components/LoadingProvider.js";
import ReCAPTCHA from "react-google-recaptcha";

const RegistrationClientForm = ({ onNext, onCancel, clientName, setClientName, showCancel, showPrevious, showNext, showSkip, nextButtonText }) => {
  const { setLoading, setTextHeader, setTextMessage, setProgress } = useLoading();
  const [isFormInvalid, setIsFormInvalid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isInputValid, setIsInputValid] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  // This is used to set REcaptcha verification to verified for integration test purposes
  useEffect(() => {
    // This [true] value should be changed depending on the set config from the file .env
    // If the value is [true], the capthca will not be shown on the page and the variable isCaptchaVerified will be set to true
    // If the value is [false], the capthca will be shown on the page and the variable isCaptchaVerified will be set to false until we click the checkbox
    setIsCaptchaVerified(process.env.REACT_APP_ENV.trim() !== "Release");
  }, []);

  useEffect(() => {
    setIsInputValid(validateInput(clientName));
  }, [clientName]);

  const handleCaptchaChange = (value) => {
    setIsCaptchaVerified(!!value);
  };

  useEffect(() => {}, [isCaptchaVerified, isFormInvalid]);

  const handleNext = async (e) => {
    // e.preventDefault();

    // check if input is filled corectly and reCapcha is verified
    if (!isInputValid || !isCaptchaVerified) {
      setIsFormInvalid(true);
      setErrorMessage(
        "Please fill in all the required fields and verify the captcha."
      );
      return;
    }

    // set loading text
    setTextHeader("Checking if company/project exists...");
    setTextMessage("twinzo is looking...");

    setLoading(true);
    setProgress(0);
    // check if client already exists via Registration controller
    fetch(`/Registration/client/exists/${clientName}`)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          // Client already exists with the given login
          setIsFormInvalid(true);
          setErrorMessage(
            "This name is already used, please choose a different one"
          );
        } else {
          // Client name is unique and valid, so we can proceed to the next form step
          setIsFormInvalid(false);
          setErrorMessage(null);
          onNext();
        }
      })
      .catch((error) => {
        setErrorMessage("Something went wrong.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // validate input value with regex
  // only letters and numbers are allowed
  // min length is 3, max length is 50
  const validateInput = (inputValue) => {
    const isValid = /^[a-zA-Z0-9]{3,50}$/.test(inputValue);
    return isValid;
  };

  const renderReCAPTCHA = () => {
    if (isCaptchaVerified === false) {
      return (
        <div className="catpcha mt-3 w-100">
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY.trim()}
            stoken={process.env.REACT_APP_RECAPTCHA_SECURE_TOKEN.trim()}
            onChange={handleCaptchaChange}
            theme="dark"
            size="normal"
          />
        </div>
      );
    } else {
      return null; // Or you can return an alternative component or message
    }
  };

  // When email list is updated, we need to adjust height of the swipeableViews according to the content
  useEffect(() => {}, [!isFormInvalid]); // Include isErrorMessageVisible in the dependency array

  return (
    <RegistrationForm
      onNext={handleNext}
      onSkip={onNext}
      onCancel={onCancel}
      isInputValid={isInputValid && isCaptchaVerified}
      showCancel={showCancel}
      showPrevious={showPrevious}
      showNext={showNext}
      showSkip={showSkip}
      nextButtonText={nextButtonText}
    >
      <div>
        <h4>Type in the name of your company/project or other</h4>
        <div className="dialogContent">
          <p>
            To begin, please provide a name for your account, organization,
            project, group, or domain. The name should be no longer than 50
            characters and cannot include any special characters.
          </p>
          <div className="form-group">
            {/* Client Login name input */}
            <input
              id="name-input"
              className={!isInputValid ? "w-100 invalid-input" : "w-100"}
              type="text"
              required
              placeholder="Name of the company/project…"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
            />
          </div>
          {renderReCAPTCHA()}
        </div>
      </div>
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </RegistrationForm>
  );
};

export default RegistrationClientForm;
